/**
 * @returns {void}
 */
module.exports = function goToForm1262ConfirmationStep() {
    const offset = (2 / 3) * 100;

    document.querySelectorAll('[data-component="form1262-stepper"]').forEach(stepper => {
        stepper.style.transform = `translateX(-${offset}%)`;
    });
};